<template>
  <el-container class="chat-page">
    <resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="chat-aside-width">
      <div class="header" :class="configStore.electronMode ? 'header-menu-wrap' : ''">
        <el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
          <i class="el-icon-search el-input__icon" slot="prefix"> </i>
        </el-input>
        <div class="header-row">
          <el-select class="remark-select" size="small" v-model="selectedRemark" placeholder="全部分组" clearable>
            <el-option v-for="remark in remarkOptions" :key="remark" :label="remark" :value="remark"></el-option>
          </el-select>
          <el-dropdown class="read-all-dropdown" trigger="click" @command="onReadAll">
            <el-button size="small" plain>一键已读<i class="el-icon-arrow-down el-icon--right"></i></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="ALL">全部</el-dropdown-item>
              <el-dropdown-item command="PRIVATE">私聊</el-dropdown-item>
              <el-dropdown-item command="GROUP">群聊</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="chat-loading" v-if="loading" v-loading="true" element-loading-text="消息接收中..."
        element-loading-spinner="el-icon-loading" element-loading-background="#F9F9F9" element-loading-size="24"></div>
      <virtual-scroller class="scroll-box" :items="showChats">
        <template v-slot="{ item }">
          <chat-item :chat="item" @click.native="onActiveItem(item)" @delete="onDelItem(item)" @info="onShowInfo(chat)"
            @dnd="onDnd(item)" @top="onTop(item)" :active="item === chatStore.activeChat"></chat-item>
        </template>
      </virtual-scroller>
    </resizable-aside>
    <el-container class="chat-box">
      <chat-box v-if="activeChat && activeChat.type != 'SYSTEM'" :chat="activeChat"></chat-box>
      <chat-system-box v-if="activeChat && activeChat.type == 'SYSTEM'" :chat="activeChat"></chat-system-box>
    </el-container>
  </el-container>
</template>

<script>
import ChatItem from "../components/chat/ChatItem.vue";
import ChatBox from "../components/chat/ChatBox.vue";
import ChatSystemBox from "../components/chat/ChatSystemBox.vue";
import ResizableAside from "../components/common/ResizableAside.vue";
import VirtualScroller from "../components/common/VirtualScroller.vue";
export default {
  name: "chat",
  components: {
    ChatItem,
    ChatBox,
    ChatSystemBox,
    ResizableAside,
    VirtualScroller
  },
  data() {
    return {
      searchText: "",
      selectedRemark: "",
      remarkOptions: [],
      messageContent: "",
      group: {},
      groupMembers: []
    };
  },
  methods: {
    // 加载好友分组(备注)列表
    loadRemarkOptions() {
      this.$http({
        url: "/friend/list/remark",
        method: "GET"
      })
        .then((remarks) => {
          this.remarkOptions = Array.isArray(remarks)
            ? [...new Set(remarks.filter((r) => r))]
            : [];
        })
        .catch(() => {
          this.remarkOptions = [];
        });
    },
    onActiveItem(chat) {
      this.chatStore.setActiveChat(chat);
    },
    // 一键已读：scope 取值 ALL(全部)/PRIVATE(私聊)/GROUP(群聊)
    onReadAll(scope) {
      let chats = this.chatStore.chats.filter((chat) => chat.unreadCount > 0);
      if (scope === "PRIVATE") {
        chats = chats.filter((chat) => chat.type === "PRIVATE");
      } else if (scope === "GROUP") {
        chats = chats.filter((chat) => chat.type === "GROUP");
      }
      if (chats.length === 0) {
        this.$message.info("暂无未读消息");
        return;
      }
      chats.forEach((chat) => {
        if (chat.type === "PRIVATE") {
          this.$http({ url: `/message/private/readed?friendId=${chat.targetId}`, method: "put" });
        } else if (chat.type === "GROUP") {
          this.$http({ url: `/message/group/readed?groupId=${chat.targetId}`, method: "put" });
        } else if (chat.type === "SYSTEM") {
          this.$http({ url: `/message/system/readed?maxSeqNo=${this.chatStore.systemMsgMaxSeqNo}`, method: "put" });
        }
      });
      this.chatStore.resetUnreadCounts(chats);
    },
    onKeydown(e) {
      if (e.key != "Escape") {
        return;
      }
      // 按 ESC 关闭当前打开的会话
      if (this.activeChat) {
        this.chatStore.activeChat = null;
      }
    },
    onDelItem(chat) {
      this.chatStore.removeChat(chat);
    },
    onShowInfo(chat) {
      if (chat.type == "PRIVATE") {
        this.$router.push("/home/friend?id=" + chat.targetId);
      } else if (chat.type == "GROUP") {
        if (!this.groupStore.isGroup(chat.targetId)) {
          this.$message.error("您已不在群聊中，无法查看群资料");
          return;
        }
        this.$router.push("/home/group?id=" + chat.targetId);
      }
    },
    onDnd(chat) {
      if (chat.type == "PRIVATE") {
        this.setFriendDnd(chat, chat.targetId, !chat.isDnd);
      } else {
        this.setGroupDnd(chat, chat.targetId, !chat.isDnd);
      }
    },
    setFriendDnd(chat, friendId, isDnd) {
      let formData = {
        friendId: friendId,
        isDnd: isDnd
      };
      this.$http({
        url: "/friend/dnd",
        method: "put",
        data: formData
      }).then(() => {
        this.friendStore.setDnd(friendId, isDnd);
        this.chatStore.setDnd(chat, isDnd);
      });
    },
    setGroupDnd(chat, groupId, isDnd) {
      let formData = {
        groupId: groupId,
        isDnd: isDnd
      };
      this.$http({
        url: "/group/dnd",
        method: "put",
        data: formData
      }).then(() => {
        this.groupStore.setDnd(groupId, isDnd);
        this.chatStore.setDnd(chat, isDnd);
      });
    },
    onTop(chat) {
      if (chat.type == "PRIVATE") {
        this.setFriendTop(chat, chat.targetId, !chat.isTop);
      } else {
        this.setGroupTop(chat, chat.targetId, !chat.isTop);
      }
    },
    setFriendTop(chat, friendId, isTop) {
      let formData = {
        friendId: friendId,
        isTop: isTop
      };
      this.$http({
        url: "/friend/top",
        method: "put",
        data: formData
      }).then(() => {
        this.friendStore.setTop(friendId, isTop);
        this.chatStore.setTop(chat, isTop);
      });
    },
    setGroupTop(chat, groupId, isTop) {
      let formData = {
        groupId: groupId,
        isTop: isTop
      };
      this.$http({
        url: "/group/top",
        method: "put",
        data: formData
      }).then(() => {
        this.groupStore.setTop(groupId, isTop);
        this.chatStore.setTop(chat, isTop);
      });
    },
    isShowChat(chat) {
      // 搜索文本过滤
      if (this.searchText && !chat.showName.includes(this.searchText)) {
        return false;
      }
      // 分组(备注)过滤：仅私聊会话参与分组
      if (this.selectedRemark) {
        return chat.type == "PRIVATE" && chat.remark === this.selectedRemark;
      }
      return true;
    }
  },
  computed: {
    activeChat() {
      return this.chatStore.activeChat;
    },
    loading() {
      return this.chatStore.loading;
    },
    showChats() {
      return this.chatStore.chats.filter((chat) => this.isShowChat(chat));
    }
  },
  mounted() {
    this.loadRemarkOptions();
    window.addEventListener("keydown", this.onKeydown);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeydown);
  }
};
</script>

<style lang="scss">
.chat-page {
  .header {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 6px;
    padding: 8px 12px;

    .header-row {
      display: flex;
      align-items: center;
      gap: 6px;
    }

    .remark-select {
      flex: 1;
      width: auto;
    }

    .read-all-dropdown {
      flex-shrink: 0;

      // 移除按钮全局的浮动效果
      .el-button {
        box-shadow: none;

        &:hover {
          transform: none;
          box-shadow: none;
        }
      }
    }
  }

  .chat-loading {
    height: 50px;
    background-color: #eee;

    .el-icon-loading {
      font-size: 24px;
      color: var(--im-text-color-light);
    }

    .el-loading-text {
      color: var(--im-text-color-light);
    }

    .chat-loading-box {
      height: 100%;
    }
  }

  .chat-items {
    flex: 1;
  }
}
</style>
